import { Translations } from '../../i18n/Translations'
import { assertExhaustion } from '../../lib/typeHelpers.no-deps'
import type { ElementOrNested } from './element.no-deps'

export function elementTypeName(elementType: ElementOrNested['type']) {
    switch (elementType) {
        case 'calculation':
            return Translations.t('shared:flow.elementType.calculation')
        case 'checkbox':
            return Translations.t('shared:flow.elementType.checkBox')
        case 'confirmation':
            return Translations.t('shared:flow.elementType.confirmation')
        case 'datetime':
            return Translations.t('shared:flow.elementType.dateTime')
        case 'dropdown':
            return Translations.t('shared:flow.elementType.dropDown')
        case 'files-select':
            return Translations.t('shared:flow.elementType.filesUpload')
        case 'flow':
            return Translations.t('shared:flow.elementType.subTask')
        case 'guide':
            return Translations.t('shared:flow.elementType.guide')
        case 'image-content':
            return Translations.t('shared:flow.elementType.image')
        case 'image-select':
            return Translations.t('shared:flow.elementType.imageSelect')
        case 'link':
            return Translations.t('shared:flow.elementType.link')
        case 'loop':
            return Translations.t('shared:flow.elementType.loop')
        case 'number':
            return Translations.t('shared:flow.elementType.number')
        case 'photo':
            return Translations.t('shared:flow.elementType.camera')
        case 'radio':
            return Translations.t('shared:flow.elementType.multipleChoice')
        case 'section':
            return Translations.t('shared:flow.elementType.section')
        case 'signature':
            return Translations.t('shared:flow.elementType.signature')
        case 'text-capture':
            return Translations.t('shared:flow.elementType.textCapture')
        case 'text-content':
            return Translations.t('shared:flow.elementType.textContent')
        case 'unit-select':
            return Translations.t('shared:flow.elementType.unitSelect')
        case 'video-content':
            return Translations.t('shared:flow.elementType.video')
        case 'yes-no':
            return Translations.t('shared:flow.elementType.yesNo')
        default:
            assertExhaustion(elementType)
    }
}
